import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-eta-approximation-item',
  templateUrl: './eta-approximation-item.component.html',
  styleUrls: ['./eta-approximation-item.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class EtaApproximationItemComponent implements OnInit {

  @Input()
  duration: number;

  @Input()
  labelKey: string;

  @Input()
  itemName: string;

  @Input()
  writeMode = true;

  @Output()
  durationChange = new EventEmitter<number>();

  spanLabelKey: string;

  durationInput: number;

  constructor() {
  }

  ngOnInit() {
    this.durationInput = this.duration;

    if (this.duration == null)  {
      this.spanLabelKey = 'eta-approximations.trip-duration.next-day';
    } else {
      this.spanLabelKey = 'eta-approximations.trip-duration.unit';
    }
  }

  durationChanged(): void {
    this.durationChange.emit(this.duration);
  }

}
